module.exports = __webpack_public_path__ + "img/banner.21a3d669.jpg";